export default class UtilsString {
  static truncate(str, lengthStr = 45) {
    if (UtilsString.hasLength(str, lengthStr)) {
      return str.substr(0, lengthStr) + '...';
    }
    return str;
  }

  static hasLength(string, lengthStr = 45) {
    return ![undefined, null].includes(string) && string.length > lengthStr;
  }

  static capitalize(string) {
    if (string) {
      const withoutUnderline = string.split('_').join(' ').toLowerCase();
      return withoutUnderline[0].toUpperCase() + withoutUnderline.slice(1);
    }
  }

  static firstLetterEachWord(name) {
    if (typeof name === 'string' && name.length > 0) {
      return name.charAt(0);
    }
    return '';
  }

  static generateUuid() {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
    );
  }

  static formatBytes(bytes, decimals = 2) {
    if (!+bytes) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  }

  static indent(val = '', n = 1) {
    return '\t'.repeat(n) + val;
  }

  static includes(str = '', val = '') {
    const normalizedStr = str
      .normalize('NFD')
      .replace(/[\u0300-\u036F]/g, '')
      .toLowerCase();

    const normalizedVal = val
      .normalize('NFD')
      .replace(/[\u0300-\u036F]/g, '')
      .toLowerCase();

    return normalizedStr.includes(normalizedVal);
  }

  static normalizeQa(value) {
    if (!value) return '';

    return value
      ?.toString()
      .normalize('NFD') // separa acentos
      .replace(/[\u0300-\u036f]/g, '') // remove acentos
      .replace(/[^a-zA-Z0-9-_]/g, '-') // troca caracteres inválidos por "-"
      .replace(/-+/g, '-') // evita múltiplos "-"
      .toLowerCase();
  }
}
